import React from 'react'
import PropTypes from 'prop-types'
import { InputGroupAddon, SVGIcon } from 'components/qstrap'

const ValidationIcon = (props) => {
  if (!props.enabled) return null

  let icon = props.valid ? 'tick' : 'close'
  const color = props.valid ? 'success' : 'danger'

  if (props.valid === undefined) icon = ''

  return (
    <InputGroupAddon className="icon-bg-transparent validation-tag">
      <SVGIcon name={icon} className={`text-${color}`} />
    </InputGroupAddon>
  )
}

ValidationIcon.propTypes = {
  valid: PropTypes.bool,
  enabled: PropTypes.bool,
}

export default ValidationIcon
